;(function () {
  'use strict'

  angular.module('pub.shinies.service', []).factory('ShiniesService', ShiniesService)

  /** @ngInject */
  function ShiniesService($http, $q, API) {
    function save(collectibleId, model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/collectibles/' + collectibleId + '/shinies', model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function update(id, model) {
      var defered = $q.defer()

      $http
        .put(API.API_URL + 'publisher/shinies/' + id, model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function remove(id) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'publisher/shinies/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function publish(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/shinies/' + id + '/publish')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function unpublish(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/shinies/' + id + '/unpublish')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function replicate(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/shinies/' + id + '/replicate')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function createBountyShiny(bundleId, amount) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/bundles/' + bundleId + '/shinies/for_amount/' + amount)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function deleteBountyShiny(bundleId, amount) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'publisher/bundles/' + bundleId + '/shinies/for_amount/' + amount)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function activateShiny(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + `publisher/shinies/${id}/activate`)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function deactivateShiny(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + `publisher/shinies/${id}/deactivate`)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    return {
      save: save,
      remove: remove,
      update: update,
      publish: publish,
      unpublish: unpublish,
      createBountyShiny: createBountyShiny,
      deleteBountyShiny: deleteBountyShiny,
      activateShiny,
      deactivateShiny,
      replicate,
    }
  }
})()
